module.exports = __webpack_public_path__ + "images/Bubbles_MangoandPassionfruit_1.png";